import { render } from "./Spinner.vue?vue&type=template&id=75558903&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=75558903&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-75558903"

export default script